import React, { ComponentType, HTMLAttributes } from 'react';
import { styled } from '@mui/material';

const Curtain: ComponentType<HTMLAttributes<HTMLDivElement>> = styled('div')({
  pointerEvents: 'none',
  position: 'fixed',
  inset: '0 0 0 0',
  background: '#00000080',
  zIndex: 1101,
  color: '#FFFFFF',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  justifyContent: 'center',
  gap: '40px',
  fontSize: '33px',
  fontWeight: '400',
});

export default Curtain;